import { Directive, EventEmitter, Input, OnChanges } from '@angular/core';

@Directive({
  selector: 'form[meta], form-row[meta]'
})
export class MetaDirective implements OnChanges {
  @Input()
  meta;

  metaChanges = new EventEmitter<any>();

  ngOnChanges() {
    if (this.meta) {
      this.metaChanges.emit(this.meta);
    }
  }
}
